import React, { forwardRef, useState } from 'react';
import { resolveImage } from './resolveImage';

const ImageAttempt = forwardRef(function ImageAttempt({ resolved, alt = '', loading = 'lazy', decoding = 'async', sizes, fetchPriority, fetchpriority, onError, onLoad, width, height, ...props }, ref) {
  const [stage, setStage] = useState(0);
  const src = stage >= 4 ? resolved.placeholder : stage >= 3 ? resolved.original : resolved.src;
  const srcSet = stage < 3 ? resolved.srcSet : undefined;
  return (
    <picture style={{ display: 'contents' }}>
      {stage === 0 && resolved.avif && <source type="image/avif" srcSet={resolved.avif} sizes={sizes || resolved.sizes} />}
      {stage <= 1 && resolved.webp && <source type="image/webp" srcSet={resolved.webp} sizes={sizes || resolved.sizes} />}
      <img {...props} ref={ref} src={src} srcSet={srcSet} sizes={srcSet ? sizes || resolved.sizes : undefined}
        alt={alt} width={width ?? resolved.width} height={height ?? resolved.height}
        loading={loading} decoding={decoding} fetchpriority={fetchPriority || fetchpriority || 'auto'}
        onLoad={onLoad}
        onError={(event) => {
          if (stage < 4) {
            // Unsupported codecs, missing derivatives and a failed original all have finite retries.
            setStage(stage === 0 && !resolved.avif ? (resolved.webp ? 2 : 3) : stage + 1);
          } else if (stage === 4) { setStage(5); onError?.(event); }
        }} />
    </picture>
  );
});
const ElakayImage = forwardRef(function ElakayImage({ image, src, preset = 'product-card', fallback, ...props }, ref) {
  const resolved = resolveImage(image || src, preset, fallback);
  return <ImageAttempt key={`${resolved.original}|${preset}|${resolved.srcSet || ''}|${resolved.avif || ''}`} resolved={resolved} {...props} ref={ref} />;
});
export default ElakayImage;
